export const contactCardColumnTestId = "cdp-contact-card-column";
